<header>
  <skip-nav></skip-nav>

  @if (screenSize!=='mobile') {
  <axis-navbar
    axisSticky
    class="_border-none size-large _bg-primary"
  >
    <axis-navbar-logo>
      <a href>
        <img
          alt="AIG logo"
          src="assets/images/logos/aig-logo.svg"
        />
        <span class="sr-only">American International Group, Inc.</span>
      </a>
    </axis-navbar-logo>
    <axis-navbar-app-title i18n="@@navbar.heading"> Claims Digital Portal</axis-navbar-app-title>
    @if (router.url.match('claim-overview')) {
    <axis-navbar-right>
      <ng-template [ngTemplateOutlet]="navbarRightTop"></ng-template>
    </axis-navbar-right>
    }
  </axis-navbar>
  }


  @if (screenSize === 'mobile') {
  <nav
    class="axis-navbar-mobile _bg-primary"
    [ngClass]="{'open':navbarOpen}"
    axisSticky="0"
  >
    <div
      class="axis-mobile-overlay"
      (click)="closeOverlay()"
    ></div>
    <div class="axis-mobile-header">
      <div class="axis-navbar-title">
        <axis-navbar-logo>
          <a href>
            <img
              alt="AIG logo"
              src="assets/images/logos/aig-logo.svg"
            />
            <span class="sr-only">American International Group, Inc.</span>
          </a>
        </axis-navbar-logo>
        <axis-navbar-app-title i18n="@@navbar.heading"  
        axis-tooltip
        axis-truncate
        class="_w-px-200"
        [content]="titleContent"
        > Claims Digital Portal</axis-navbar-app-title>
      </div>
    </div>
  </nav>
  }

</header>